module.exports = __webpack_public_path__ + "img/png.4d931864.svg";